import React from 'react';
import { motion } from 'framer-motion';
import { PartnrMark } from '@/components/partnr/kit/PartnrMark';
import { GlassCard } from '../GlassCard';
import { GlassCTA } from '../GlassCTA';

interface HookStepProps {
  onComplete: () => void;
}

export function HookStep({ onComplete }: HookStepProps) {
  return (
    <GlassCard>
      <div className="flex flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="mb-6 flex h-14 w-14 items-center justify-center rounded-full border border-line bg-paper-sunken text-ink"
        >
          <PartnrMark size={28} state="done" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="font-display text-[28px] font-semibold text-ink tracking-tight"
        >
          You're all set.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          className="mt-5 text-lg leading-relaxed"
          style={{ color: 'hsl(var(--ink-2))' }}
        >
          Your boards are ready. Drop ideas, notes and files onto your canvas,
          and I'll help keep everything organized.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
          className="mt-10"
        >
          <GlassCTA onClick={onComplete}>Enter your workspace</GlassCTA>
        </motion.div>
      </div>
    </GlassCard>
  );
}
